"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_js_1 = __importDefault(require("crypto-js"));
const base64UrlEncode = (buffer) => {
    return buffer
        .toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};
const createCodeChallenge = (codeVerifier, method = 'S256') => {
    if (method === 'plain') {
        return codeVerifier;
    }
    return crypto_js_1.default.enc.Base64url.stringify(crypto_js_1.default.SHA256(codeVerifier));
};
exports.default = createCodeChallenge;
